import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mobileHeaderLocation",
  "use": "mobileHeaderLocation-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol viewBox=\"0 0 18 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"mobileHeaderLocation\"><g fill=\"none\" stroke=\"#9c7446\" stroke-width=\"1.15\" stroke-miterlimit=\"10\"><path d=\"m17.3 8.7c0 4.6-8.3 14.4-8.3 14.4s-8.3-9.8-8.3-14.4 3.7-8.3 8.3-8.3 8.3 3.7 8.3 8.3z\" /><circle cx=\"9\" cy=\"9\" r=\"3.2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol